/**
 * Arquivo: src/utils/touchInteractionGuard.ts
 * Versão: 4.10.98
 * Data: 17/09/2026
 *
 * Impede que o toque usado para fechar uma camada alcance controles que
 * reaparecem imediatamente atrás dela em navegadores móveis/PWA.
 */

const CLASSE_PROTECAO = 'touch-dismiss-guard'
let temporizador: number | undefined

export function protegerAposFechamentoPorToque(detalheDoClique = 1) {
  if (detalheDoClique === 0 || typeof window === 'undefined' || typeof document === 'undefined') return

  const dispositivoComToque = window.matchMedia?.('(pointer: coarse)').matches
    || navigator.maxTouchPoints > 0

  if (!dispositivoComToque) return

  document.body.classList.add(CLASSE_PROTECAO)
  if (temporizador !== undefined) window.clearTimeout(temporizador)
  temporizador = window.setTimeout(() => {
    document.body.classList.remove(CLASSE_PROTECAO)
    temporizador = undefined
  }, 400)
}
